<template>
    <div class="rate-selection">

        <div class="mb-4">
            <booking-summary v-bind:highlight="true"></booking-summary>
            <div class="mb-4">
                <current-action v-bind:roomIndex="leg"
                                v-bind:action="'Select Rate'"></current-action>
            </div>
            <div v-if="hasError && !isLoading">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-xl-12">
                            <info-box v-bind:type="'error'">
                                <template v-slot:body>
                                    <span class="heading">
                                        Error
                                    </span>

                                    <div>
                                        <p>An error has occurred. Please click on <strong><span style="cursor: pointer" v-on:click="startOver()">here</span></strong> below to search again.</p>
                                    </div>
                                </template>
                            </info-box>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="!hasError && !isLoading" class="every-rate">
                <div class="container">
                    <h4 class="every-rate-heading">{{content.everyRate.title}}</h4>

                    <div class="every-rate-inner row">
                        <div class="col-24 col-md mb-3 mb-md-0 every-rate-item" v-for="(everyRateItem, index) in content.everyRate.items">
                            <div class="col-24">
                                <div class="row">
                                    <div class="col-6 d-flex justify-content-center">
                                        <img v-if="everyRateItem.Image"
                                             v-bind:src="everyRateItem.Image.Path" />
                                    </div>
                                    <div class="col-18">
                                        <span class="every-rate-title">{{everyRateItem.Title}}</span>
                                        <div class="every-rate-body" v-html="everyRateItem.Body"></div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                </div>
            </div>
        </div>


        <div v-if="!hasError && !isLoading" class="container rate-panels">
            <div class="row">
                <div class="col-24">


                    <rate-panel v-on:loading="isLoading = !isLoading"
                                v-on:error="onShowError()"
                                v-for="rateGroup in availableRateGroups"
                                v-bind:key="rateGroup.Key"
                                v-bind:leg="leg"
                                v-bind:rateGroup="rateGroup"></rate-panel>

                </div>
            </div>
        </div>


        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>

    </div>




</template>

<script>
    import BookingSummary from '../components/BookingSummary.vue';
    import CurrentAction from '../components/CurrentAction.vue';
    import RatePanel from '../components/RatePanel.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';

    import Loader from '@/shared/components/Loader.vue';
    import { store } from '../store/index';

    export default {
        name: 'RateSelection',
        components: {
            BookingSummary,
            CurrentAction,
            RatePanel,
            Loader,
            InfoBox
        },
        computed: {
            session() {
                return store.getters.session
            },
            content() {
                return store.getters.roomConfiguration.Content.rates;
            },
            leg() {
                return this.$route.params.leg;
            },
            booking() {
                return store.getters.booking;
            },
            rateAvailability() {
                return store.getters.rateAvailability(this.leg);
            },
            rateConfiguration() {
                return store.getters.roomConfiguration.RateGroups;
            },
            availableRateGroups() {

                let availability = store.getters.rateAvailability(this.leg);
                let roomConfiguration = store.getters.roomConfiguration;
                let flatRates = store.getters.roomConfiguration.FlatRates;
                let rateGroups = roomConfiguration.RateGroups;


                let result = [];
                for (let rgi in rateGroups) {
                    let rateGroup = rateGroups[rgi];
                    rateGroup.AvailableRates = [];

                    for (let rgri in rateGroup.Rates) {
                        let rateGroupRate = rateGroup.Rates[rgri];
                        let availableRate = availability.find(item => item.RateCode == rateGroupRate.PMSCode);

                        if (availableRate != null) {
                            availableRate.IsAllocatedGroup = true;
                            rateGroup.AvailableRates.push({ rateGroupRate, availableRate });;

                        }

                    }

                    if (rateGroup.AvailableRates.length) {
                        result.push(rateGroup);
                    }
                }



                let unclassifiedRateGroups = []


                for (let a in availability) {
                    let avail = availability[a];
                    if (avail.IsAllocatedGroup == undefined || !avail.IsAllocatedGroup) {
                        let rateCode = avail.RateCode;

                        let flatRate = flatRates.find(item => item.PMSCode == rateCode);
                        if (flatRate != null) {

                            var dummyGroup = {

                                DisplayName: flatRate.DisplayName,
                                Description: flatRate.Description,
                                Images: flatRate.Images,
                                AvailableRates: []
                            };

                            dummyGroup.AvailableRates.push({
                                rateGroupRate: flatRate,
                                availableRate: avail
                            })
                            unclassifiedRateGroups.push(dummyGroup)
                        }
                        else {
                            var dummyGroup = {
                                DisplayName: avail.Name,
                                Description: avail.Description,
                                Images: [{
                                    Path: '/media/nlupktcc/ohp_205_spielman.jpg?width=377&height=320&mode=crop'
                                }],
                                AvailableRates: []
                            };

                            dummyGroup.AvailableRates.push({
                                rateGroupRate: {
                                    DisplayName: avail.Name,
                                }, availableRate: avail
                            })
                            unclassifiedRateGroups.push(dummyGroup)
                        }



                    }
                }

                if (unclassifiedRateGroups.length) {
                    result = result.concat(unclassifiedRateGroups);
                };

                return result;
            },
        },
        data() {
            return {
                hasError: false,
                isLoading: false
            }
        },
        mounted() {
            this.trackRates();
        },
        methods: {

            onShowError() {
                this.hasError = true;
                this.isLoading = false;
            },
            startOver() {

                store.dispatch("ignoreBooking");
                store.dispatch("clearData").then(() => {

                    this.$router.push({ name: 'stay_start' });
                });
            },

            trackRates() {

                if (this.$gtm.enabled()) {

                    let items = [];

                    for (let i = 0; i < this.availableRateGroups.length; i++) {

                        let rateGroups = this.availableRateGroups[i];
                        for (let y = 0; y < rateGroups.AvailableRates.length; y++) {

                            let rates = rateGroups.AvailableRates[y];
                            let item = {
                                'item_id': rates.availableRate.RateCode,
                                'item_name': rates.rateGroupRate.DisplayName,
                                'item_list_name': rateGroups.DisplayName,
                                'currency': rates.availableRate.Currency,
                                'discount': rates.rateGroupRate.DiscountAmount,
                                'price': rates.availableRate.Amount

                            };
                            items.push(item);
                        }

                    }

                    window.dataLayer?.push({
                        'pageURL': '/stay/rate/' + this.leg,
                        'event': 'view_item_list',
                        'ecommerce': {
                            'item_list_name': 'Rate Availability',
                            'items': [items]
                        }
                    });
                }

            },



        }
    }
</script>

<style src="@/modules/stay/css/rate-selection.css"></style>
